import { NORMAL_GRAIN, DEFAULT_MOTION_BLUR_ALPHA } from "./data";

type RenderContext = CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;

export const lcd = {
  motionBlurAlpha: DEFAULT_MOTION_BLUR_ALPHA,
  grainDepth: NORMAL_GRAIN,
  motionBlurEnabled: true,
  grainEnabled: true,
  _prevCanvas: null as OffscreenCanvas | null,
  _prevCtx: null as OffscreenCanvasRenderingContext2D | null,

  setMotionBlurAlpha(value: number): void {
    if (value < 0.4) value = 0.4;
    if (value > 1.0) value = 1.0;
    this.motionBlurAlpha = value;
  },

  setGrainDepth(value: number): void {
    if (value < 0) value = 0;
    this.grainDepth = value;
  },

  applyMotionBlur(ctx: RenderContext, w: number, h: number): void {
    if (!this.motionBlurEnabled || this.motionBlurAlpha >= 1.0) return;

    if (!this._prevCanvas || this._prevCanvas.width !== w || this._prevCanvas.height !== h) {
      this._prevCanvas = new OffscreenCanvas(w, h);
      this._prevCtx = this._prevCanvas.getContext("2d")!;
      this._prevCtx.drawImage(ctx.canvas, 0, 0);
      return;
    }

    const prevCtx = this._prevCtx!;
    ctx.globalAlpha = 1 - this.motionBlurAlpha;
    ctx.drawImage(this._prevCanvas, 0, 0);
    ctx.globalAlpha = 1;

    prevCtx.clearRect(0, 0, w, h);
    prevCtx.drawImage(ctx.canvas, 0, 0);
  },

  applyGrain(ctx: RenderContext, w: number, h: number): void {
    if (!this.grainEnabled || this.grainDepth <= 0) return;

    const imageData = ctx.getImageData(0, 0, w, h);
    const data = imageData.data;
    const depth = this.grainDepth * 255;

    for (let i = 0; i < data.length; i += 4) {
      const noise = (Math.random() - 0.5) * depth;
      data[i] += noise;
      data[i + 1] += noise;
      data[i + 2] += noise;
    }

    ctx.putImageData(imageData, 0, 0);
  },
};
